// extracted by mini-css-extract-plugin
export default {"wrap":"InputForm_wrap__xZCv6","wrap__label":"InputForm_wrap__label__QKEUa","wrap__input":"InputForm_wrap__input__7xahJ","error":"InputForm_error__PYsou"};